import React, { useState, useRef, useEffect } from "react";
import SearchIcon from "../../images/SearchIcon.svg";
import clearTextIconBlue from "../../images/clearTextBlue.svg";
import { ClickAwayListener } from "@mui/material";
import "./RoundedSearchTextField.scss";
import SearchButton from "./SearchButton";

const SearchFilterTextField = ({
  placeholder = "Search...",
  onTextChange,
  handleSearch,
  expandable,
  setIsSearchBarEmpty,
  isSearchBarEmpty,
  inputValue: controlledInputValue = "",
  onClear,
}) => {
  const [inputValue, setInputValue] = useState(controlledInputValue || "");
  const searchButtonRef = useRef("");
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    setInputValue(controlledInputValue || "");
  }, [controlledInputValue]);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (e) => {
    // setInputValue("");
    // onTextChange("");
    // setIsSearchBarEmpty(true);
    // setIsFocused(false);
  };

  const clearTextField = () => {
    setInputValue("");
    setIsSearchBarEmpty(true);
    onTextChange("");
    if (typeof onClear === "function") onClear();
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch(event);
    }
  };

  const handleSearchClick = (event) => {
    handleSearch(event);
  };

  return (
    <div
      className={`tf-rounded-search ${expandable ? "expandable" : ""} ${
        isFocused ? "focused" : ""
      }`}
    >
      <ClickAwayListener onClickAway={handleBlur}>
        <div
          className="d-flex align-items-center"
          style={{ position: "relative", width: "100%" }}
        >
          <img src={SearchIcon} alt="" className="search-icon" />
          <input
            id="tf-search-field"
            type="text"
            value={inputValue || ""}
            placeholder={placeholder}
            onFocus={handleFocus}
            className="search-input"
            autoComplete="off"
            onKeyPress={handleKeyPress}
            onDrop={(e) => e.preventDefault()}
            style={{ paddingRight: isFocused ? "100px" : "10px" }} // Add padding for icons
            onChange={(e) => {
              if (e.target.value?.trim().length > 0) {
                setInputValue(e.target.value);
                setIsSearchBarEmpty(false);
              } else {
                setIsSearchBarEmpty(true);
                setInputValue("");
              }
              onTextChange(e.target.value);
            }}
          />

          {isFocused && (
            <div
              style={{
                position: "absolute",
                right: "8px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <SearchButton
                ref={searchButtonRef}
                className="filtersearch"
                handleClick={(event) => {
                  handleSearchClick(event);
                }}
                disabled={isSearchBarEmpty}
                title="Search"
                height="32px"
              />

              <img
                src={clearTextIconBlue}
                alt="Clear text"
                style={{ cursor: "pointer", width: "16px", height: "16px" }}
                onClick={() => {
                  if (inputValue.length > 0) {
                    clearTextField();
                  } else {
                    handleBlur();
                  }
                }}
              />
            </div>
          )}
        </div>
      </ClickAwayListener>
    </div>
  );
};

export default SearchFilterTextField;
